import React from 'react';
import { HelpSectionContent } from '../data/stepHelpContent';
import styles from '../styles/stepHelpPanel.module.css';

interface HelpSectionViewProps {
  content: HelpSectionContent;
}

function renderInline(text: string): React.ReactNode {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    return part;
  });
}

const HelpSectionView: React.FC<HelpSectionViewProps> = ({ content }) => (
  <div className={styles.sectionBody}>
    <p className={styles.lead}>{renderInline(content.description)}</p>
    {content.details && <p className={styles.details}>{content.details}</p>}
    {content.steps && content.steps.length > 0 && (
      <ol className={styles.stepsList}>
        {content.steps.map((step, index) => (
          <li key={index}>{renderInline(step)}</li>
        ))}
      </ol>
    )}
    {content.menuItems && content.menuItems.length > 0 && (
      <ul className={styles.menuItemsList}>
        {content.menuItems.map((item) => (
          <li key={item.label}>
            <strong>{item.label}</strong>
            {' — '}
            {item.description}
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default HelpSectionView;
